"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeIncrementer = void 0;
/**
 * Build a function that returns an incremented value at every call
 *
 * ```ts
 * const increment = makeIncrementer();
 * console.log(increment()); // 1
 * console.log(increment()); // 2
 * console.log(increment()); // 3
 * ```
 */
const makeIncrementer = () => ((x) => () => x++)(1);
exports.makeIncrementer = makeIncrementer;
//# sourceMappingURL=makeIncrementer.js.map